import api from '@/api/api';

export default {

    namespaced: true,

    state: {
        mostrarFirma: true
    },
    mutations: {

        convertirVariableTrue(state, datos) {
            state.mostrarFirma = true;
        },

        convertirVariableFalse(state, datos) {
            state.mostrarFirma = false;
        },

    },
    actions: {

        async convertirVariableTrue({ commit }) {
            commit('convertirVariableTrue');
        },

        async convertirVariableFalse({ commit }) {
            commit('convertirVariableFalse');
        },



    },
};
